import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { grey, red, yellow, blue } from '@material-ui/core/colors';
import Slide from '@material-ui/core/Slide';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';

import AAPlayerWrapper from './AAPlayerWrapper';
import Feedback from './Feedback';

const styles = (theme) => ({
	root: {
		overflow: 'hidden'
	},
	hidden: {
		display: 'none'
	},
	text: {
		padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 4}px`,
		display: 'flex',
		alignItems: 'center'
	},
	answer: {
		minHeight: 64,
		'& span': {
			color: 'black'
		},
		'& span[data-bad]': {
			background: `${red[500]} !important`
		},
		'& span[data-soso]': {
			background: `${yellow[500]} !important`
		},
		'& span[data-ok]': {
			background: `${blue[200]} !important`
		},
		'& span[data-unknown]': {
			color: `${red[500]} !important`
		}
	},
	num: {
		padding: '6px 12px',
		marginRight: theme.spacing.unit * 2,
		borderRadius: '50%',
		backgroundColor: grey[200],
		fontWeight: 600,
		display: 'flex',
		alignSelf: 'self-start'
	}
});

class Item extends Component {
	renderQuestionNum() {
		const { classes, numeration } = this.props;

		if (numeration) {
			return (
				<Typography
					variant="title"
					className={classNames(classes.num)}
					color="default"
				>
					{numeration}
				</Typography>
			);
		}

		return undefined;
	}

	render() {
		const { classes, index, itemIndex, visible, text, answered, basePath, markedText, showMarkedText, audioPrefix, audioEnabled } = this.props;
		let textWithNewlines = showMarkedText ? markedText || text : text;
		textWithNewlines = textWithNewlines.replace(/\(-\)/g,'<br>');
		return (
			<div className={classNames(classes.root, { [classes.hidden]: !visible })}>
				<Slide direction="right" timeout={answered ? 0 : 300} in={visible}>
					<div className={classes.text}>
						{this.renderQuestionNum()}
						<Typography
							variant="headline"
							className={classes.answer}
							dangerouslySetInnerHTML={{ __html: textWithNewlines }}
							color="default"
						/>
					</div>
				</Slide>
				<AAPlayerWrapper itemIndex={index} listenPath={audioEnabled ? `${basePath}audio/${audioPrefix}${itemIndex + 1}.mp3` : null} />
				<Feedback answered={answered} />
			</div>
		);
	}
}

Item.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired, // eslint-disable-line
	itemIndex: PropTypes.number.isRequired,
	visible: PropTypes.bool.isRequired,
	answered: PropTypes.bool.isRequired,
	basePath: PropTypes.string.isRequired,
	showMarkedText: PropTypes.bool.isRequired,
	markedText: PropTypes.string,
	numeration: PropTypes.number,
	audioPrefix: PropTypes.string.isRequired,
	audioEnabled: PropTypes.bool.isRequired,
};

Item.defaultProps = {
	numeration: undefined,
	markedText: undefined
};

function mapStateToProps({
	exercise: { currentItem, autoNum, itemsMarkedText, audioPrefix, audioEnabled },
	loader: { testMode, testSent, basePath }
}, ownProps) {
	return {
		audioEnabled,
		audioPrefix,
		basePath,
		visible: currentItem === ownProps.index,
		numeration: autoNum ? ownProps.index + 1 : undefined,
		markedText: itemsMarkedText[ownProps.index],
		showMarkedText: !testMode || testSent,
		answered: Boolean(itemsMarkedText[ownProps.index] !== undefined) || testSent
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Item);
